import {Grid} from '@logistics-frontend/blocks'
import {Typographyv2 as Typography} from '@logistics-frontend/blocks/v2'
import {PaymentMethod} from '@yandex-taxi/js-integration-api'
import clsx from 'clsx'
import React from 'react'

import {classes} from './PaymentOption.classes'

type Props = {
  method: PaymentMethod
}

const PaymentOption: React.FC<Props> = ({method}) => {
  const iconClass = method.id === 'cash' ? classes.iconCash : classes[`icon${method.label}`]
  const description = method.description ? `${method.label} · ${method.description}` : method.label
  const mobileDescription = method.id === 'cash' ? method.label : method.description

  return (
    <Grid alignItems="center" className={classes.radioItem} direction="row" justify="center" container>
      <Grid className={clsx(classes.icon, iconClass)} item />
      <Typography className={classes.methodText} thickness="regular" variant="body2">
        {description}
      </Typography>
      <Typography className={classes.methodTextMobile} thickness="regular" variant="body2">
        {mobileDescription}
      </Typography>
    </Grid>
  )
}

export default PaymentOption
